















import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';

@Component({
  name: 'SwitchWithLabel'
})
export default class SwitchWithLabel extends Vue {
  @Prop({ type: Boolean, default: false })
  value!: boolean;

  localChecked: boolean = false;

  @Watch('value', { immediate: true })
  onValuePropChange(checked: boolean) {
    this.localChecked = checked;
  }

  @Prop({ type: String, required: false })
  label!: string;

  @Prop({ type: Boolean, default: false })
  disabled!: boolean;

  @Prop({ type: String, default: 'small' })
  size!: 'small' | 'default';

  @Prop({ type: String, required: false })
  id?: string;

  @Prop({ type: String, required: false })
  title?: string;

  @Emit('input')
  handleChange(checked: boolean): boolean {
    return checked;
  }

  @Emit('change')
  emitChange(checked: boolean): boolean {
    return checked;
  }

  onSwitchChange(checked: boolean) {
    this.localChecked = checked;
    this.handleChange(checked);
    this.emitChange(checked);
  }
}
